import { useState } from 'react';

export type ToastType = {
  title: string;
  onClose?: (id: string) => void;
  icon?: string;
  type?: 'error' | 'warning' | 'info' | 'success' | '';
};

const useToast = () => {
  const [toast, setToast] = useState<ToastType>();

  const showToast = (data: ToastType) => {
    if (!data.icon) {
      switch (data.type) {
        case 'success':
          data.icon = 'success-default';
          break;
        case 'error':
        case 'warning':
          data.icon = 'warning-20';
          break;
        default:
          data.icon = '';
          break;
      }
    }
    setToast(data);
  };

  const removeToast = () => setToast(undefined);

  return { toast, showToast, removeToast };
};

export default useToast;
